import React from 'react'
import './DataTrustPanel.css'

interface DataTrustPanelProps {
  trustScore: number
  lastUpdated: string
}

export const DataTrustPanel: React.FC<DataTrustPanelProps> = ({ trustScore, lastUpdated }) => {
  const getConfidenceMessage = (score: number): string => {
    if (score >= 90) return 'High confidence in unified data'
    if (score >= 75) return 'Good confidence in unified data'
    if (score >= 60) return 'Moderate confidence in unified data'
    return 'Limited confidence in unified data'
  }

  const formatRelativeTime = (timestamp: string): string => {
    const now = new Date()
    const updated = new Date(timestamp)
    const diffMs = now.getTime() - updated.getTime()
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60))
    const diffMinutes = Math.floor(diffMs / (1000 * 60))

    if (diffHours >= 24) {
      const diffDays = Math.floor(diffHours / 24)
      return `${diffDays} ${diffDays === 1 ? 'day' : 'days'} ago`
    } else if (diffHours >= 1) {
      return `${diffHours} ${diffHours === 1 ? 'hour' : 'hours'} ago`
    } else if (diffMinutes >= 1) {
      return `${diffMinutes} ${diffMinutes === 1 ? 'minute' : 'minutes'} ago`
    }
    return 'Just now'
  }

  return (
    <div className="data-trust-panel">
      <div className="trust-panel-header">
        <div className="trust-panel-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          </svg>
        </div>
        <h2 className="trust-panel-title">Data Trust</h2>
      </div>

      <div className="trust-score-section">
        <div className="trust-score-label">Overall Trust Score</div>
        <div className="trust-score-value">{trustScore}%</div>
        <div className="trust-confidence-message">{getConfidenceMessage(trustScore)}</div>
      </div>

      <div className="trust-updated">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10" />
          <polyline points="12 6 12 12 16 14" />
        </svg>
        <span className="trust-updated-label">Last Updated</span>
        <span className="trust-updated-time">{formatRelativeTime(lastUpdated)}</span>
      </div>
    </div>
  )
}
